const wildcardUrlMatcher = (url, slug)=>{
    if (url === slug || url === `${slug}/`) {
        return true;
    }
    if ((url === null || url === void 0 ? void 0 : url.endsWith('/*')) && slug.startsWith(url.substring(0, url.length - 2))) {
        return true;
    }
    return false;
};

export { wildcardUrlMatcher };
//# sourceMappingURL=wildcard-url-matcher.js.map
